import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import styled from 'styled-components';
import AppLink from '../../elements/AppLink';
import ExternalLinkEl from '../../elements/ExternalLink';
import Button from '../../elements/Button';
import { TABLET, MOBILE } from '../../constants';
var Link = styled(function (_ref) {
  var menuItemColor = _ref.menuItemColor,
      desktopHoverState = _ref.desktopHoverState,
      rest = _objectWithoutPropertiesLoose(_ref, ["menuItemColor", "desktopHoverState"]);

  return /*#__PURE__*/React.createElement(AppLink, rest);
}).withConfig({
  displayName: "NavBarstyles__Link",
  componentId: "pantheon__l9hzpr-0"
})(["margin-right:2.75rem;font-weight:300;white-space:nowrap;color:", ";&:hover{", ";}", ";"], function (props) {
  return props.menuItemColor || "white";
}, function (props) {
  return props.desktopHoverState || "font-weight: 600";
}, function (props) {
  return props.selected ? props.desktopHoverState || "font-weight: 600;" : "";
});
var ExternalLink = styled(ExternalLinkEl).withConfig({
  displayName: "NavBarstyles__ExternalLink",
  componentId: "pantheon__l9hzpr-1"
})(["margin-right:2.75rem;font-weight:300;color:", ";&:hover{cursor:pointer;", ";}"], function (props) {
  return props.menuItemColor || "white";
}, function (props) {
  return props.desktopHoverState || "font-weight: 600";
});
var NavBarContainer = styled.div.withConfig({
  displayName: "NavBarstyles__NavBarContainer",
  componentId: "pantheon__l9hzpr-2"
})(["font-family:", ";background-color:", ";height:5rem;width:100%;z-index:1000;display:flex;align-items:center;justify-content:space-between;"], function (props) {
  return props.font;
}, function (props) {
  return props.headerColor || '#cfcfcf';
});
var Logo = styled.img.withConfig({
  displayName: "NavBarstyles__Logo",
  componentId: "pantheon__l9hzpr-3"
})(["height:2.5rem;width:auto;margin:0 2rem;z-index:1002;@media (max-width:56.25rem){display:none;}"]);
var MobileLogo = styled.img.withConfig({
  displayName: "NavBarstyles__MobileLogo",
  componentId: "pantheon__l9hzpr-4"
})(["margin:0 2rem;height:2.5rem;width:auto;display:none;z-index:1002;@media (max-width:56.25rem){display:block;}"]);
var Links = styled.div.withConfig({
  displayName: "NavBarstyles__Links",
  componentId: "pantheon__l9hzpr-5"
})(["margin:0 0 0 auto;color:", ";display:flex;@media (max-width:", "){display:none;}"], function (props) {
  return props.menuItemColor || "white";
}, TABLET);
var SubscribeButton = styled(Button).withConfig({
  displayName: "NavBarstyles__SubscribeButton",
  componentId: "pantheon__l9hzpr-6"
})(["margin-right:1rem;@media (max-width:", "){display:none;}"], MOBILE);
var LinkMenuSection = styled.div.withConfig({
  displayName: "NavBarstyles__LinkMenuSection",
  componentId: "pantheon__l9hzpr-7"
})(["display:flex;align-items:center;overflow:scroll;"]);
export { Logo, NavBarContainer, MobileLogo, Links, SubscribeButton, LinkMenuSection, Link, ExternalLink };